// extracted by mini-css-extract-plugin
module.exports = {"list":"HeaderItems-module--list--3UxvI","listOpen":"HeaderItems-module--listOpen--124J-"};